import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  LOCALE_ID,
  OnChanges,
  OnInit,
  Output,
  SimpleChange,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { CheckInState } from '@frontend/check-in-kiosk/feature/check-in/src';
import { tz, utc } from 'moment-timezone';

@Component({
  selector: 'frontend-check-in',
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CheckInComponent implements OnInit, OnChanges {
  @Input() state: CheckInState;
  @Output() save = new EventEmitter();

  checkInForm: FormGroup;
  format: string;

  constructor(@Inject(LOCALE_ID) public localeId: string) {}

  ngOnInit() {
    this.checkInForm = this.groupCreator(this.state);
    switch (this.localeId) {
      case 'de':
        this.format = 'HH:mm';
        break;
      default:
        this.format = 'h:mm A';
    }
  }

  ngOnChanges(data: { state: SimpleChange }) {
    if (this.checkInForm) {
      this.checkInForm.controls.workflow_id.setValue(data.state.currentValue.workflow_id);
    }
  }

  submit(data) {
    const appointment_time_utc = tz(
      data.appointment_time,
      this.format,
      true,
      this.state.timezone
    )
      .utc()
      .toISOString();

    const first = data.first_name || '';
    const last = data.last_name || '';
    const secured_patient_name =
      [first.substring(0, 3), last.substring(0, 1)].join(' ').trim() || null;

    this.save.emit({ ...data, appointment_time_utc, secured_patient_name });
  }

  private groupCreator({
    showProvider,
    showAppointmentTime,
    workflow_id,
    department_id,
  }: CheckInState) {
    const providerControl = showProvider
      ? { assigned_staff_id: new FormControl(null) }
      : undefined;
    const appointmentTimeControl = showAppointmentTime
      ? { appointment_time: new FormControl('', [this.wrongFormValidator]) }
      : undefined;
    return new FormGroup({
      tag: new FormControl('', [Validators.required, Validators.maxLength(8)]),
      first_name: new FormControl(''),
      last_name: new FormControl(''),
      cellphone: new FormControl(''),
      mrn: new FormControl(''),
      workflow_id: new FormControl(workflow_id),
      department_id: new FormControl(department_id),
      ...providerControl,
      ...appointmentTimeControl,
    });
  }

  private wrongFormValidator = (control: AbstractControl): ValidationErrors | null => {
    if (control.value === '') {
      return null;
    }
    const valid = utc(control.value, this.format, true).isValid();
    return valid ? null : { appointentWrongFormat: { value: control.value } };
  };
}
